import { render, staticRenderFns } from "./ElementsQuestionAnswer.vue?vue&type=template&id=70e4c46c"
import script from "./ElementsQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./ElementsQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports